import { EPanelId } from "source/app/services/Shared/EPanelId";
import { GetEnumIndex } from "motw_core/Utils/EnumUtils";
import {
    ActivePanel,
    defaultActivePanelId,
} from "source/app/presentation/Shared/ActivePanel/ActivePanel";
import { GetNavigationMenuItems } from "../NavigationMenu/NavigationMenuItems";
import { RouteDreams } from "../../../MainPanel/Dreams/Routing/DreamsRouting";

export function RouteUrl(activePanel: ActivePanel) {
    const panelNameFromUrl =
        activePanel.props.params.panelName ?? EPanelId[defaultActivePanelId];

    const panelIdFromUrl = GetEnumIndex(EPanelId, panelNameFromUrl);

    if (panelNameFromUrl.toLowerCase() === `dreams`) {
        RouteDreams(activePanel.props.params.elementId);
    }

    if (activePanel.state.activePanelId !== panelIdFromUrl) {
        activePanel.TransitionToPanel(panelIdFromUrl);

        SetTitleBar(panelIdFromUrl);
    }
}

function SetTitleBar(panelIdFromUrl: number) {
    const navMenuItem = GetNavigationMenuItems().find(
        (item) => item.id === panelIdFromUrl
    );

    document.title = navMenuItem!.title;
}
